import { Component, OnInit, Input, Inject } from '@angular/core';
import { EmailService } from '../../../email/data/email.service';
import { MailInfo } from '../../../email/data/mail-info';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QBService } from '../../data/qb.service';
import { MvcExceptionResponse } from 'projects/core/src/lib/core/data/mvc-exception-response';
import { ProjectSale } from '../../data/project-sale';

@Component({
    selector: 'app-email-preview',
    templateUrl: './email-preview.component.html',
    styleUrls: ['./email-preview.component.scss']
})
export class EmailPreviewComponent implements OnInit {
    emailBody = `Dear Customer,

Your invoice for cabinetry package is attached!

Let us know if you have any questions.

We appreciate your prompt payment.

Thanks for your business!
Acadia Craft, LLC`;

    sendLoading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            sale: ProjectSale
        },
        protected qbService: QBService,
        protected dialogRef: MatDialogRef<EmailPreviewComponent>
    ) { }

    ngOnInit() {
    }

    sendEmail() {
        this.sendLoading = true;

        if (this.data.sale.type === 'Estimate') {
            this.qbService.sendEstQB(this.data.sale.id).subscribe(emit => {
                this.dialogRef.close(['Success!', 'Success!']);
            }, error => {
                if (error instanceof MvcExceptionResponse) {
                    this.dialogRef.close(['Error!', error.message]);
                }
                else {
                    this.dialogRef.close(['Error!', 'Error!']);
                }
            })
        }
        else {

            this.qbService.sendInvQB(this.data.sale.id).subscribe(emit => {
                this.dialogRef.close(['Success!', 'Success!']);
            }, error => {
                if (error instanceof MvcExceptionResponse) {
                    this.dialogRef.close(['Error!', error.message]);
                }
                else {
                    this.dialogRef.close(['Error!', 'Error!']);
                }
            })
        }

    }
}
